import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function rightArrow({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="black"
      viewBox="0 0 14 15"
      width="14"
      height="15"
      className={className}
    >
      <path
        stroke="none"
        d="M13.5 6.634a1 1 0 010 1.732L2.25 14.861a1 1 0 01-1.5-.866V1.005a1 1 0 011.5-.866L13.5 6.634z"
      />
    </svg>
  );
}

export default rightArrow;
